<template>
  <div>
    <div class="form-row align-items-center">
		<div class="col-md-2">
			<div class="form-check">
			  <input v-model="imageFilter" type="checkbox" class="form-check-input" id="exampleCheck1">
			  <label class="form-check-label" for="exampleCheck1">Image</label>
			</div>
		</div>
		<div class="col-md-5">
			<label for="start" class="col-form-label text-md-right">Start after:</label>
			<div class="input-group">        
				<date-picker
				  v-model="afterFilter"
				  :max="beforeFilter"
				  type="datetime"
				  format="YYYY-MM-DD HH:mm:ss"
				  display-format="MM/DD/YYYY h:mm a"
				></date-picker>
				<button v-on:click="afterFilter = ''" class="btn btn-danger">
				  <i class="fa fa-minus"></i>
				</button>
			</div>
		</div>
		<div class="col-md-4">
			<label for="start" class="col-form-label text-md-right">Finish before:</label> 
			<div class="input-group">
				<date-picker
				  v-model="beforeFilter"
				  :min="afterFilter"
				  type="datetime"
				  format="YYYY-MM-DD HH:mm:ss"
				  display-format="MM/DD/YYYY h:mm a"
				></date-picker>
				<button v-on:click="beforeFilter = ''" class="btn btn-danger">
				  <i class="fa fa-minus"></i>
				</button>
			</div>
		</div>
    </div>
    
    <div class="row justify-content-center m-2">
      <div class="col-md-4">
        <select v-model="statusFilter" class="custom-select mr-sm-2" id="inlineFormCustomSelect">
            <option value="" selected>Event Status</option>
            <option v-for="(value, key) in statustypes" :value="key" :key="key" v-if="key != statusTypesDraftCode">
                {{value}}
            </option>
        </select>
      </div>
      <div class="col-md-4">
        <select v-model="pageFilter" class="custom-select mr-sm-2" id="inlineFormCustomSelect">
            <option value="" selected>Page</option>
            <option v-for="(value, key) in totalPages" :value="value" :key="key">
                {{value}}
            </option>
        </select>
      </div>
      <div class="col-md-4">
        <select v-model="venueIdFilter" class="custom-select mr-sm-2" id="inlineFormCustomSelect">
            <option value="" selected>Venue</option>
            <option v-for="{name, id} in venues" :value="id" :key="id">
                {{name}}
            </option>
        </select>
      </div>
    </div>
    <div class="row justify-content-center m-2">
      <div v-for="show in shows" :key="show.id" class="col-md-4 py-2">
        <single-show :show="show"/>
      </div>
    </div>
  </div>
</template>

<script>
import SingleShow from "./SingleShow";
//import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import VueDatetimeJs from 'vue-datetime-js';
export default {
  props: {
      statustypes: '',
      statusTypesDraftCode: Number,
      venues: Array,
      now: '',
  },

  data() {
    return {
      requestURL: "/event/shows/api",
      data: [],
      //filters: {
           //image: false,
      //},
      imageFilter: false,
      afterFilter: "",
      beforeFilter: "",
      statusFilter: "",
      venueIdFilter: "",
      pageFilter: "",
    };
  },

  created() {
    this.fetchShows();
    this.afterFilter = this.now;
  },
        
  methods: {
    fetchShows() {
      //console.log(this.showsUrl);
      axios.get(this.showsUrl).then(res => {
      	//console.log(res)
        this.data = res.data;
      });
    },
    hasFilter(input) {
        return !(input == null || input == "")
    }
  },

  watch: {
    imageFilter: function(input) {
      this.fetchShows();
    },
    afterFilter: function(input) {
      this.fetchShows();
    },
    beforeFilter: function(input) {
      this.fetchShows();
    },
    statusFilter: function(input) {
      this.fetchShows();
    },
    pageFilter: function(input) {
      this.fetchShows();
    },
    venueIdFilter: function(input) {
      this.fetchShows();
    },
  },

  computed: {
    showsUrl: function() {
      var showsUrl = this.requestURL + "?" + $.param(this.filters);
      return showsUrl;
    },
    filters: function() {
      var filters = {};

      if (this.imageFilter === true) {
        filters.image = 1;
      }

      if (this.hasFilter(this.afterFilter)) {
        filters.after = this.afterFilter;
      }
      if (this.hasFilter(this.beforeFilter)) {
        filters.before = this.beforeFilter;
      }
      if (this.hasFilter(this.statusFilter)) {
        filters.status = this.statusFilter;
      }
      if (this.hasFilter(this.pageFilter)) {
        filters.page = this.pageFilter;
      }
      if (this.hasFilter(this.venueIdFilter)) {
        filters.venue_id = this.venueIdFilter;
      }

      return filters;
    },

    shows: function() {
    //console.log(this.data.data);
      return this.data.data;
    },
    
    totalPages: function() {
        if ( (this.data.length != 0) && this.hasFilter(this.data.meta.last_page)) {
            return this.data.meta.last_page;
        }
        return 1;
    },

  },

  components: {
    SingleShow,
   // datePicker: VuePersianDatetimePicker,
	datePicker: VueDatetimeJs,
  }
};
</script>
